<p-accordion [value]="props?.attributes?.isOpen ?? 0">
    <p-accordion-panel [value]="0" [disabled]="disableAccordion">
        <p-accordion-header>{{ props?.label }}</p-accordion-header>
        <p-accordion-content>
            <ng-container #fieldComponent></ng-container>
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>
